module.exports = __webpack_public_path__ + "static/media/th0rsteinnf.9abe6921.svg";